import type { FaqItem } from "@/types/content";

export const faqItems: FaqItem[] = [
  {
    question: "51吃瓜今天有什么瓜，多久更新一次？",
    answer:
      "本站每天持续更新今日新鲜瓜，通常在早晚两个时段集中上新；遇到热点集中出现的时间段，会不定时补充。打开首页即可在「今日新瓜」时间线里按时间顺序查看。",
  },
  {
    question: "本站的内容都来自哪里？",
    answer:
      "内容由编辑团队整理公开信息与行业动向后重新撰写，注重来源可核实、表达中立克制。我们不搬运未经确认的说法，也不发布涉及他人隐私的猜测性内容。",
  },
  {
    question: "热瓜榜是怎么排出来的？",
    answer:
      "热瓜榜综合了近期的阅读量、收藏与讨论热度进行排序，并会在每天固定时间刷新。榜单只是一个快速入口，点开后仍然可以查看完整的来龙去脉。",
  },
  {
    question: "可以在手机上正常浏览吗？",
    answer:
      "可以。全站采用响应式设计，手机、平板和电脑都能正常阅读。移动端顶部提供可展开的导航菜单，长文页面也针对小屏做了字号与行距优化。",
  },
  {
    question: "我想推荐一个话题或投稿，怎么联系？",
    answer:
      "欢迎通过「关于我们」页面底部的联系方式与我们沟通，或在页面留言区说明你的话题方向。我们会认真阅读每一条建议，合适的内容会安排进一步跟进。",
  },
  {
    question: "为什么有些热门事件本站没有跟进？",
    answer:
      "我们更看重信息的可靠性与表达的边界。对于来源不明、涉及隐私或容易产生误导的话题，通常会选择观望而不急于跟风，这也是我们坚持的内容原则。",
  },
];